import ARCCard from "components/ARC/ARCCard";
import CloseButton from "components/layout/CloseButton";

const SelectARC = ({
    arcsInfo,
    arcStatuses,
    cardOnClickTitle = "Control",
    cardOnClick = () => {},
    onClose = () => {},
}) => {
    return (
        <div className="selector">
            <CloseButton className="absolute right-3 top-3" onClick={onClose} />
            <p className="weight-bold">Choose ARC</p>
            <div className="scroll-horizontal flex w-full  items-center justify-start space-x-4">
                {arcsInfo.map((arc) => (
                    <ARCCard
                        key={arc.serialNumber}
                        arc={arc}
                        arcStatus={arcStatuses[arc.serialNumber]}
                        actionTitle={cardOnClickTitle}
                        onClick={() => {
                            cardOnClick(arc);
                            onClose();
                        }}
                        className="max-w-Card"
                    />
                ))}
            </div>
        </div>
    );
};

export default SelectARC;
